var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full mb-6",class:{'lg:w-3/4': !_vm.fullWidth}},[_vm._t("leftSide")],2),(this.$slots.rightSide)?_c('div',{staticClass:"vx-col w-full",class:{'lg:w-1/4': !_vm.fullWidth}},[_vm._t("rightSide")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }